import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

interface Props {
  lang: 'en' | 'ru' | 'it' | 'fr';
}

export default function Search({ lang }: Props) {
  const { t } = useTranslation('search');
  const tc = useTranslation('common').t;

  return (
    <Layout lang={lang}>
      <div className="blog-post">
        <h2 className="blog-post-title">{t('title')}</h2>
        <p className="blog-post-meta">
          {t('date')} &nbsp;|&nbsp; <Link to={lang === 'en' ? '/' : `/${lang}`}>{tc('mainPage')}</Link>
        </p>
        <hr />
        <p>{t('intro')}</p>

        <h4>{t('phpDev.title')}</h4>
        <p><em>{t('phpDev.note')}</em></p>
        <p>{t('phpDev.text')}</p>

        <h4>{t('leadDev.title')}</h4>
        <p>{t('leadDev.text')}</p>

        <h4>{t('teamLead.title')}</h4>
        <p>{t('teamLead.text')}</p>

        <h4>{t('manager.title')}</h4>
        <p>{t('manager.text')}</p>
      </div>
    </Layout>
  );
}
